export const COLORS = {
    // isLight is used to determine whether the icon for this colour should be white or black
    // hex is used within activity digest emails as
    NONE: { name: null, css: null, hex: null, isLight: true },
    GREY: { name: 'GREY', css: 'var(--color-element-grey)', hex: '#5f6672', isLight: false },
    CYAN: { name: 'CYAN', css: 'var(--color-element-cyan)', hex: '#62dbc8', isLight: true },
    GREEN: { name: 'GREEN', css: 'var(--color-element-green)', hex: '#7cd651', isLight: true },
    BROWN: { name: 'BROWN', css: 'var(--color-element-brown)', hex: '#d58558', isLight: true },
    YELLOW: { name: 'YELLOW', css: 'var(--color-element-yellow)', hex: '#ffd14d', isLight: true },
    ORANGE: { name: 'ORANGE', css: 'var(--color-element-orange)', hex: '#ff8d48', isLight: true },
    RED: { name: 'RED', css: 'var(--color-element-red)', hex: '#ff5757', isLight: true },
    PINK: { name: 'PINK', css: 'var(--color-element-pink)', hex: '#ff6ed4', isLight: true },
    PURPLE: { name: 'PURPLE', css: 'var(--color-element-purple)', hex: '#ad6fff', isLight: true },
    BLUE: { name: 'BLUE', css: 'var(--color-element-blue)', hex: '#4ebafd', isLight: true },
    DEEP_BLUE: { name: 'DEEP_BLUE', css: 'var(--color-element-deep-blue)', hex: '#5882f8', isLight: false },
};

export const BACKGROUND_COLORS = {
    NONE: { ...COLORS.NONE },
    GREY: { ...COLORS.GREY, hex: '#bbbec3' },
    CYAN: { ...COLORS.CYAN },
    GREEN: { ...COLORS.GREEN },
    BROWN: { ...COLORS.BROWN },
    YELLOW: { ...COLORS.YELLOW },
    ORANGE: { ...COLORS.ORANGE },
    RED: { ...COLORS.RED },
    PINK: { ...COLORS.PINK },
    PURPLE: { ...COLORS.PURPLE },
    BLUE: { ...COLORS.BLUE },
    DEEP_BLUE: { ...COLORS.DEEP_BLUE },
    TRANSPARENT: { name: 'TRANSPARENT', css: 'rgba(0,0,0,0)', hex: '#00000000', className: 'transparent' },
};

export const SKETCH_BACKGROUND_COLORS = {
    WHITE: { name: 'WHITE', css: 'rgba(255,255,255,1)', hex: '#ffffff', isLight: true },
    CHARCOAL: { name: 'CHARCOAL', css: 'rgba(51,51,51,1)', hex: '#333333', isLight: false },
    GREY: { ...COLORS.GREY },
    CYAN: { ...COLORS.CYAN },
    GREEN: { ...COLORS.GREEN },
    BROWN: { ...COLORS.BROWN },
    YELLOW: { ...COLORS.YELLOW },
    ORANGE: { ...COLORS.ORANGE },
    RED: { ...COLORS.RED },
    PINK: { ...COLORS.PINK },
    PURPLE: { ...COLORS.PURPLE },
    BLUE: { ...COLORS.BLUE },
    DEEP_BLUE: { ...COLORS.DEEP_BLUE },
};

export const SKETCH_LINE_COLORS = {
    ...COLORS,
    WHITE: { name: 'WHITE', css: 'rgba(255,255,255,1)', hex: '#ffffff', isLight: true },
};

export const SKETCH_LINE_COLORS_ARRAY = Object.values(SKETCH_LINE_COLORS);

export const DEFAULT_BOARD_COLOR = '#cacaca';
export const DEFAULT_ELEMENT_COLOR = '#ffffff';

export const CANVAS_COLORS = {
    // isLight is used to determine whether the icon for this colour should be white or black
    NONE: { name: null, css: null, displayName: 'Grey' },
    BLUE: { name: 'BLUE', css: 'var(--color-canvas-blue)' },
    GREEN: { name: 'GREEN', css: 'var(--color-canvas-green)' },
    YELLOW: { name: 'YELLOW', css: 'var(--color-canvas-yellow)' },
    WARM_GREY: { name: 'WARM_GREY', css: 'var(--color-canvas-warm-grey)' },
    // Gradients
    // HEAVEN_GRADIENT: { name: 'HEAVEN_GRADIENT', css: 'var(--color-canvas-gradient-heaven)' },
    // SKY_GRADIENT: { name: 'SKY_GRADIENT', css: 'var(--color-canvas-gradient-sky)' },
    // DUSK_GRADIENT: { name: 'DUSK_GRADIENT', css: 'var(--color-canvas-gradient-dusk)' },
    // SUNSET_GRADIENT: { name: 'SUNSET_GRADIENT', css: 'var(--color-canvas-gradient-sunset)' },
    // OCEAN_GRADIENT: { name: 'OCEAN_GRADIENT', css: 'var(--color-canvas-gradient-ocean)' },
    // BLUE_GRADIENT: { name: 'BLUE_GRADIENT', css: 'var(--color-canvas-gradient-blue)' },
    // SOFT_GRADIENT: { name: 'SOFT_GRADIENT', css: 'var(--color-canvas-gradient-soft)' },
    // GREEN_GRADIENT: { name: 'GREEN_GRADIENT', css: 'var(--color-canvas-gradient-green)' },
    // LIME_GRADIENT: { name: 'LIME_GRADIENT', css: 'var(--color-canvas-gradient-lime)' },
    // HONEY_DEW_GRADIENT: { name: 'HONEY_DEW_GRADIENT', css: 'var(--color-canvas-gradient-honey-dew)' },
    // STRIPE_GRADIENT: { name: 'STRIPE_GRADIENT', css: 'var(--color-canvas-gradient-stripe)' },
    // WATER_GRADIENT: { name: 'WATER_GRADIENT', css: 'var(--color-canvas-gradient-water)' },
    // COCKTAIL_GRADIENT: { name: 'COCKTAIL_GRADIENT', css: 'var(--color-canvas-gradient-cocktail)' },
    // YELLOW_GRADIENT: { name: 'YELLOW_GRADIENT', css: 'var(--color-canvas-gradient-yellow)' },
    // PINK_GRADIENT: { name: 'PINK_GRADIENT', css: 'var(--color-canvas-gradient-pink)' },
    // PURPLE_GRADIENT: { name: 'PURPLE_GRADIENT', css: 'var(--color-canvas-gradient-purple)' },
    // DRIBBLE_GRADIENT: { name: 'DRIBBLE_GRADIENT', css: 'var(--color-canvas-gradient-dribble)' },
    // POPULAR_GRADIENT: { name: 'POPULAR_GRADIENT', css: 'var(--color-canvas-gradient-popular)' },
};

export const COLOR_SPACE = {
    HEX: 'HEX',
    RGB: 'RGB',
    HSL: 'HSL',
};

// Used by color swatch to indicate format of color values displayed
export const COLOR_DISPLAY = {
    ...COLOR_SPACE,
    OFF: 'Off',
};
